import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { profileUpdateService } from "../../Network/services/profileUpdateService";
import { validateKeyInput } from "../../utils/commonFunction";
import { useLocation, useHistory } from "react-router-dom";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";

import "../../assets/css/referenceEdit.css";

import Select from "react-dropdown-select";
const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const ReferenceEditView = (props) => {
  let location = useLocation();
  let history = useHistory();


  const [projectLocation, setProjectLocation] = useState("Only Local within 50 km");

  const [personalName, setpersonalName] = useState("");
  const [personalMobile, setpersonalMobile] = useState("");
  const [personalProfession, setpersonalProfession] = useState("");
  const [personalUsername, setpersonalUsername] = useState("");
  const [personalName1, setpersonalName1] = useState("");
  const [personalMobile1, setpersonalMobile1] = useState("");
  const [personalProfession1, setpersonalProfession1] = useState("");
  const [personalUsername1, setpersonalUsername1] = useState("");

  const [professionalName, setprofessionalName] = useState("");
  const [professionalMobile, setprofessionalMobile] = useState("");
  const [professionalProfession, setprofessionalProfession] = useState("");
  const [professionalUsername, setprofessionalUsername] = useState("");
  const [professionalName1, setprofessionalName1] = useState("");
  const [professionalMobile1, setprofessionalMobile1] = useState("");
  const [professionalProfession1, setprofessionalProfession1] = useState("");
  const [professionalUsername1, setprofessionalUsername1] = useState("");

  const [morePersonal, setMorePersonal] = useState(false);
  const [moreProfessional, setMoreProfessional] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");

  useEffect(() => {
    let user = JSON.parse(window.localStorage.getItem("UserData"));
    setName(user.first_name + " " + user.last_name);

    setProjectLocation(user.project_take_from);
    let personal_preference_name1_array = user.personal_preference_name1.split(
      ","
    );
    let personal_preference_mobile1_array = user.personal_preference_mobile1.split(
      ","
    );
    let personal_preference_profession1_array = user.personal_preference_profession1.split(
      ","
    );
    let personal_prefe_fws_username1_array = user.personal_prefe_fws_username1.split(
      ","
    );

    if (personal_preference_name1_array.length > 0) {
      if (personal_preference_name1_array.length > 1) {
        setpersonalName(personal_preference_name1_array[0]);
        setpersonalName1(personal_preference_name1_array[1]);
        setMorePersonal(true);
      } else {
        setpersonalName(personal_preference_name1_array[0]);
      }
    }

    if (personal_preference_mobile1_array.length > 0) {
      if (personal_preference_mobile1_array.length > 1) {
        setpersonalMobile(personal_preference_mobile1_array[0]);
        setpersonalMobile1(personal_preference_mobile1_array[1]);
        setMorePersonal(true);
      } else {
        setpersonalMobile(personal_preference_mobile1_array[0]);
      }
    }
    if (personal_preference_profession1_array.length > 0) {
      if (personal_preference_profession1_array.length > 1) {
        setpersonalProfession(personal_preference_profession1_array[0]);
        setpersonalProfession1(personal_preference_profession1_array[1]);
        setMorePersonal(true);
      } else {
        setpersonalProfession(personal_preference_profession1_array[0]);
      }
    }
    if (personal_prefe_fws_username1_array.length > 0) {
      if (personal_prefe_fws_username1_array.length > 1) {
        setpersonalUsername(personal_prefe_fws_username1_array[0]);
        setpersonalUsername1(personal_prefe_fws_username1_array[1]);
        setMorePersonal(true);
      } else {
        setpersonalUsername(personal_prefe_fws_username1_array[0]);
      }
    }

    let personal_preference_name2_array = user.personal_preference_name2.split(
      ","
    );
    let personal_preference_mobile2_array = user.personal_preference_mobile2.split(
      ","
    );
    let personal_preference_profession2_array = user.personal_preference_profession2.split(
      ","
    );
    let personal_prefe_fws_username2_array = user.personal_prefe_fws_username2.split(
      ","
    );
    if (personal_preference_name2_array.length > 0) {
      if (personal_preference_name2_array.length > 1) {
        setprofessionalName(personal_preference_name2_array[0]);
        setprofessionalName1(personal_preference_name2_array[1]);
        setMoreProfessional(true);
      } else {
        setprofessionalName(personal_preference_name2_array[0]);
      }
    }

    if (personal_preference_mobile2_array.length > 0) {
      if (personal_preference_mobile2_array.length > 1) {
        setprofessionalMobile(personal_preference_mobile2_array[0]);
        setprofessionalMobile1(personal_preference_mobile2_array[1]);
        setMoreProfessional(true);
      } else {
        setprofessionalMobile(personal_preference_mobile2_array[0]);
      }
    }
    if (personal_preference_profession2_array.length > 0) {
      if (personal_preference_profession2_array.length > 1) {
        setprofessionalProfession(personal_preference_profession2_array[0]);
        setprofessionalProfession1(personal_preference_profession2_array[1]);
        setMoreProfessional(true);
      } else {
        setprofessionalProfession(personal_preference_profession2_array[0]);
      }
    }
    if (personal_prefe_fws_username2_array.length > 0) {
      if (personal_prefe_fws_username2_array.length > 1) {
        setprofessionalUsername(personal_prefe_fws_username2_array[0]);
        setprofessionalUsername1(personal_prefe_fws_username2_array[1]);
        setMoreProfessional(true);
      } else {
        setprofessionalUsername(personal_prefe_fws_username2_array[0]);
      }
    }
  }, []);

  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };

  const profileupdate = () => {
    const nameFields = [
      { value: personalName, field: 'Personal Reference Name' },
      { value: personalName1, field: 'Personal Reference Name 1' },
      { value: professionalName, field: 'Professional Reference Name' },
      { value: professionalName1, field: 'Professional Reference Name 1' }
    ];
    
    for (const nameField of nameFields) {
      if (nameField.value) {
        const trimmedValue = nameField.value.toString().trim();
        if (trimmedValue.length < 1 || trimmedValue.length > 60) {
          toast.error(`${nameField.field} must be between 1 and 60 characters`, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          setLoading(false);
          return;
        }
      }
    }

    const mobileFields = [
      { value: personalMobile, field: 'Personal Reference Mobile' },
      { value: personalMobile1, field: 'Personal Reference Mobile 1' },
      { value: professionalMobile, field: 'Professional Reference Mobile' },
      { value: professionalMobile1, field: 'Professional Reference Mobile 1' }
    ];

    const indianMobileRegex = /^[6-9][0-9]{9}$/;
    for (const mobileField of mobileFields) {
      if (mobileField.value) {
        const trimmedValue = mobileField.value.toString().trim();
        if (!indianMobileRegex.test(trimmedValue)) {
          toast.error(`${mobileField.field} must be a valid Indian mobile number (10 digits starting with 6, 7, 8, or 9)`, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          setLoading(false);
          return;
        }
      }
    }

    const emailFields = [
      { value: personalUsername, field: 'Personal Reference GigFWS Username' },
      { value: personalUsername1, field: 'Personal Reference GigFWS Username 1' },
      { value: professionalUsername, field: 'Professional Reference GigFWS Username' },
      { value: professionalUsername1, field: 'Professional Reference GigFWS Username 1' }
    ];

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    for (const emailField of emailFields) {
      if (emailField.value) {
        const trimmedValue = emailField.value.toString().trim();
        if (!emailRegex.test(trimmedValue)) {
          toast.error(`${emailField.field} must be a valid email address`, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          setLoading(false);
          return;
        }
      }
    }
    
    setLoading(true);
    let name =
      morePersonal == false ? personalName : personalName + "," + personalName1;
    let mobile =
      morePersonal == false
        ? personalMobile
        : personalMobile + "," + personalMobile1;
    let profession =
      morePersonal == false
        ? personalProfession
        : personalProfession + "," + personalProfession1;
    let username =
      morePersonal == false
        ? personalUsername
        : personalUsername + "," + personalUsername1;

    let professionalname =
      moreProfessional == false
        ? professionalName
        : professionalName + "," + professionalName1;
    let professionalmobile =
      moreProfessional == false
        ? professionalMobile
        : professionalMobile + "," + professionalMobile1;
    let professionalprofession =
      moreProfessional == false
        ? professionalProfession
        : professionalProfession + "," + professionalProfession1;
    let professionalusername =
      moreProfessional == false
        ? professionalUsername
        : professionalUsername + "," + professionalUsername1;

    const form = new FormData();
    form.append("project_take_from", projectLocation);

    form.append("personal_preference_name1[]", name);
    form.append("personal_preference_mobile1[]", mobile);
    form.append("personal_preference_profession1[]", profession);
    form.append("personal_prefe_fws_username1[]", username);

    form.append("personal_preference_name2[]", professionalname);
    form.append("personal_preference_mobile2[]", professionalmobile);
    form.append("personal_preference_profession2[]", professionalprofession);
    form.append("personal_prefe_fws_username2[]", professionalusername);

    profileUpdateService
      .profileUpdatecall(form)
      .then(async (res) => {
        if (res.status == 200) {
          window.localStorage.setItem("UserData", JSON.stringify(res.data[0]));
          window.localStorage.setItem("auth_token", res.data[0].auth_token);
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          history.goBack();
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const redirect = () => {
    history.push("/referenceUpdate");
  };

  function onChangeKmValue(e) {
    setProjectLocation(e.target.value);

  }

  const preventComma = (e) => {
    if (e.key === ',' || e.key === 'Comma') {
      e.preventDefault();
    }
  };

  const filterComma = (value, setter) => {
    const filteredValue = value.replace(/,/g, '');
    setter(filteredValue);
  };

  return (
    <LoadingOverlay>
      <section className="explore explore1">
      <div className="container">
        <div className="banner">
          <div className="row">
            <div className="col-md-4">
              <div className="breadcrumps">
                <ul>
                  <li>
                    <a href="#!" onClick={(e) => back(e)}>
                      <i className="bx bx-chevron-left" /> Back to Profile
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <section className="onbord-section">
          <div className="row">
            <div className="col-md-12 text-center">
            <h1 className="title">{name}, tell us a bit more about yourself</h1>
            <p className="subtitle">GigFWS needs the below information to help you better.</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="board-box board-box2">
              <div className="one">
                <div className="row">
                  <div className="col-md-12">
                    <p>Projects you would like to take from</p>                    
                  </div>
              </div>

              </div>
                <div className="two">
                  <div className="row">

                  <div className="form-group radi-btn-form-sec">
 
                    <div className="radio-toolbar" onChange={onChangeKmValue}>
                      <input type="radio" id="radioApple" value="Only Local within 50 km" checked={projectLocation === "Only Local within 50 km"} />
                      <label for="radioApple">Only Local <span>within 50 km</span></label>

                      <input type="radio" id="radioBanana" value="Within the City within 100 km" checked={projectLocation === "Within the City within 100 km"} />
                      <label for="radioBanana">Within the City<span>within 100 km</span></label>

                      <input type="radio" id="radioOrange" value="Within District" checked={projectLocation === "Within District"} />
                      <label for="radioOrange">Within District</label> 
                      
                      <input type="radio" id="radioApple1" value="Within State" checked={projectLocation === "Within State"} />
                      <label for="radioApple1">Within State</label>

                      <input type="radio" id="radioBanana1" value="Within Country" checked={projectLocation === "Within Country"} />
                      <label for="radioBanana1">Within Country</label>

                      <input type="radio" id="radioOrange1" value="Open to anywhere" checked={projectLocation === "Open to anywhere"} />
                      <label for="radioOrange1">Open to anywhere</label> 
                    </div>
                  </div>

                  <div className="col-md-12">
                    <p>Personal References</p>
                    <p className="subtitle">
                      Add minimum two personal references
                    </p>
                  </div>
                  <div className="col-md-12">
                    <div className="box">
                      <div className="col-md-12">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            required="required"
                            placeholder="Name (Min. 1 and Max. 60 characters)"
                            value={professionalName}
                            onInput={(e) => {
                              const filteredValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                              if (e.target.value !== filteredValue) {
                                e.target.value = filteredValue;
                                setprofessionalName(filteredValue);
                              }
                            }}
                            onChange={(e) => {
                              const filteredValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                              setprofessionalName(filteredValue);
                            }}
                            onPaste={(e) => {
                              e.preventDefault();
                              const pastedText = (e.clipboardData || window.clipboardData).getData('text');
                              const filteredText = pastedText.replace(/[^a-zA-Z\s]/g, '');
                              const newValue = professionalName + filteredText;
                              const finalValue = newValue.substring(0, 60);
                              setprofessionalName(finalValue);
                            }}
                            onKeyDown={(e) => {
                              validateKeyInput(e, /^[a-zA-Z\s]$/);
                            }}
                            maxLength={60}
                          />
                        </div>
                      </div>
                        <div className="col-md-12">
                        <div className="form-group">
                          <input
                            type="tel"
                            className="form-control"
                            required="required"
                            placeholder="Mobile Number "
                            value={professionalMobile}
                            onChange={(e) => {
                              filterComma(e.target.value, setprofessionalMobile);
                            }}
                            onKeyDown={preventComma}
                            maxLength={10}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <input
                            type="text"
                            className="form-control"
                            required="required"
                            placeholder="Profession"
                            value={professionalProfession}
                            onChange={(e) => {
                              filterComma(e.target.value, setprofessionalProfession);
                            }}
                            onKeyDown={preventComma}
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <input
                            type="email"
                            className="form-control"
                            required="required"
                            placeholder="GigFWS Username (Email)"
                            value={professionalUsername}
                            onChange={(e) => {
                              filterComma(e.target.value, setprofessionalUsername);
                            }}
                            onKeyDown={preventComma}
                          />
                        </div>
                      </div>
                      <button
                        className="btn reference-add-btn"
                        onClick={() => {
                          moreProfessional
                            ? setMoreProfessional(false)
                            : setMoreProfessional(true);
                        }}
                      >
                        {moreProfessional ? "Remove" : "Add"}
                      </button>
                      {moreProfessional && (
                        <div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <input
                                type="text"
                                name
                                className="form-control"
                                required="required"
                                placeholder="Name (Min. 1 and Max. 60 characters)"
                                value={professionalName1}
                                onInput={(e) => {
                                  const filteredValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                  if (e.target.value !== filteredValue) {
                                    e.target.value = filteredValue;
                                    setprofessionalName1(filteredValue);
                                  }
                                }}
                                onChange={(e) => {
                                  const filteredValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                  setprofessionalName1(filteredValue);
                                }}
                                onPaste={(e) => {
                                  e.preventDefault();
                                  const pastedText = (e.clipboardData || window.clipboardData).getData('text');
                                  const filteredText = pastedText.replace(/[^a-zA-Z\s]/g, '');
                                  const newValue = professionalName1 + filteredText;
                                  const finalValue = newValue.substring(0, 60);
                                  setprofessionalName1(finalValue);
                                }}
                                onKeyDown={(e) => {
                                  validateKeyInput(e, /^[a-zA-Z\s]$/);
                                }}
                                maxLength={60}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <input
                                type="tel"
                                name
                                className="form-control"
                                required="required"
                                placeholder="Mobile Number "
                                value={professionalMobile1}
                                onChange={(e) => {
                                  filterComma(e.target.value, setprofessionalMobile1);
                                }}
                                onKeyDown={preventComma}
                                maxLength={10}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <input
                                type="text"
                                name
                                className="form-control"
                                required="required"
                                placeholder="Profession"
                                value={professionalProfession1}
                                onChange={(e) => {
                                  filterComma(e.target.value, setprofessionalProfession1);
                                }}
                                onKeyDown={preventComma}
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <input
                                type="email"
                                name
                                className="form-control"
                                required="required"
                                placeholder="GigFWS Username (Email)"
                                value={professionalUsername1}
                                onChange={(e) => {
                                  filterComma(e.target.value, setprofessionalUsername1);
                                }}
                                onKeyDown={preventComma}
                              />
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  </div>
                </div>

                <div className="two margin-bottom">
                  <div className="row">
                    <div className="col-md-12">
                      <p>Professional References</p>
                      <p className="subtitle">
                      Add minimum two professional references
                      </p>
                    </div>
                    <div className="col-md-12">
                      <div className="box">
                        <div className="col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              name
                              className="form-control"
                              required="required"
                              placeholder="Name (Min. 1 and Max. 60 characters)"
                              value={personalName}
                              onInput={(e) => {
                                const filteredValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                if (e.target.value !== filteredValue) {
                                  e.target.value = filteredValue;
                                  setpersonalName(filteredValue);
                                }
                              }}
                              onChange={(e) => {
                                const filteredValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                setpersonalName(filteredValue);
                              }}
                              onPaste={(e) => {
                                e.preventDefault();
                                const pastedText = (e.clipboardData || window.clipboardData).getData('text');
                                const filteredText = pastedText.replace(/[^a-zA-Z\s]/g, '');
                                const newValue = personalName + filteredText;
                                const finalValue = newValue.substring(0, 60);
                                setpersonalName(finalValue);
                              }}
                              onKeyDown={(e) => {
                                validateKeyInput(e, /^[a-zA-Z\s]$/);
                              }}
                              maxLength={60}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <input
                              type="tel"
                              name
                              className="form-control"
                              required="required"
                              placeholder="Mobile Number "
                              value={personalMobile}
                              onChange={(e) => {
                                filterComma(e.target.value, setpersonalMobile);
                              }}
                              onKeyDown={preventComma}
                              maxLength={10}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <input
                              type="text"
                              name
                              className="form-control"
                              required="required"
                              placeholder="Profession"
                              value={personalProfession}
                              onChange={(e) => {
                                filterComma(e.target.value, setpersonalProfession);
                              }}
                              onKeyDown={preventComma}
                            />
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group">
                            <input
                              type="email"
                              name
                              className="form-control"
                              required="required"
                              placeholder="GigFWS Username (Email)"
                              value={personalUsername}
                              onChange={(e) => {
                                filterComma(e.target.value, setpersonalUsername);
                              }}
                              onKeyDown={preventComma}
                            />
                          </div>
                        </div>
                        <button
                          className="btn reference-add-btn"
                          onClick={() => {
                            morePersonal
                              ? setMorePersonal(false)
                              : setMorePersonal(true);
                          }}
                        >
                          {morePersonal ? "Remove" : "Add"}
                        </button>
                        {morePersonal && (
                          <div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <input
                                  type="text"
                                  name
                                  className="form-control"
                                  required="required"
                                  placeholder="Name (Min. 1 and Max. 60 characters)"
                                  value={personalName1}
                                  onInput={(e) => {
                                    const filteredValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                    if (e.target.value !== filteredValue) {
                                      e.target.value = filteredValue;
                                      setpersonalName1(filteredValue);
                                    }
                                  }}
                                  onChange={(e) => {
                                    const filteredValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                    setpersonalName1(filteredValue);
                                  }}
                                  onPaste={(e) => {
                                    e.preventDefault();
                                    const pastedText = (e.clipboardData || window.clipboardData).getData('text');
                                    const filteredText = pastedText.replace(/[^a-zA-Z\s]/g, '');
                                    const newValue = personalName1 + filteredText;
                                    const finalValue = newValue.substring(0, 60);
                                    setpersonalName1(finalValue);
                                  }}
                                  onKeyDown={(e) => {
                                    validateKeyInput(e, /^[a-zA-Z\s]$/);
                                  }}
                                  maxLength={60}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <input
                                  type="tel"
                                  name
                                  className="form-control"
                                  required="required"
                                  placeholder="Mobile Number "
                                  value={personalMobile1}
                                  onChange={(e) => {
                                    filterComma(e.target.value, setpersonalMobile1);
                                  }}
                                  onKeyDown={preventComma}
                                  maxLength={10}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <input
                                  type="text"
                                  name
                                  className="form-control"
                                  required="required"
                                  placeholder="Profession"
                                  value={personalProfession1}
                                  onChange={(e) => {
                                    filterComma(e.target.value, setpersonalProfession1);
                                  }}
                                  onKeyDown={preventComma}
                                />
                              </div>
                            </div>
                            <div className="col-md-12">
                              <div className="form-group">
                                <input
                                  type="email"
                                  name
                                  className="form-control"
                                  required="required"
                                  placeholder="GigFWS Username (Email)"
                                  value={personalUsername1}
                                  onChange={(e) => {
                                    filterComma(e.target.value, setpersonalUsername1);
                                  }}
                                  onKeyDown={preventComma}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-12 post-new-job reference-edit-button">
                  <button onClick={profileupdate}>Submit</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
      <Loader loading={loading} />
    </LoadingOverlay>    
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ReferenceEditView);
